import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export const options = {
  plugins: {
    legend: {
      position: 'bottom',
    },
    title: {
      display: true,
      text: 'Overrall Pass/Fail',
      font: {
        size: 24
      }
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
  labels : ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
    {
      label: 'Dataset 1',
      data: [500, 60, 50, 80, 90, 999, 22],
      backgroundColor: 'rgb(255, 99, 132)',
    },
    {
      label: 'Dataset 2',
      data: [99, 50, 480, 90, 999, 60, 96],
      backgroundColor: 'rgb(75, 192, 192)',
    },
    {
      label: 'Dataset 3',
      data: [90, 999, 60, 96, 99, 50, 480],
      backgroundColor: 'rgb(53, 162, 235)',
    },
  ],
};

// export function ChartBar() {
//   return <Bar options={options} data={data} plugins={[ChartDataLabels]}/>;
// }

export const ChartBar = (setData) => {
  return <Bar options={options} data={data} plugins={[ChartDataLabels]}/>;
};